<template>
  <div class="component-card">
    <j-title-header :options="title"/>

    <b-row>
      <b-col md="12">
        <b-form-group :class="{'error-input' : $v.data_master.nama_lengkap.$error}">
          <label> Nama Lengkap </label>
          <j-input
            v-model="$v.data_master.nama_lengkap.$model"
            placeholder="Nama Lengkap"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.nis.$error}">
          <label> NIS </label>
          <j-input
            v-model="$v.data_master.nis.$model"
            placeholder="NIS"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.nisn.$error}">
          <label> NISN </label>
          <j-input
            v-model="$v.data_master.nisn.$model"
            placeholder="NISN"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.tempat_lahir.$error}">
          <label> Tempat Lahir </label>
          <j-input
            v-model="$v.data_master.tempat_lahir.$model"
            placeholder="Tempat Lahir"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.tanggal_lahir.$error}">
          <label> Tanggal Lahir </label>
          <j-datepicker
            v-model="$v.data_master.tanggal_lahir.$model"
            placeholder="Tanggal Lahir"
            format="MMM dd, yyyy"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.jenis_kelamin.$error}">
          <label> Jenis Kelamin </label>
          <b-form-radio-group
            v-model="$v.data_master.jenis_kelamin.$model"
            :options="list_jenis_kelamin"
            :stacked="true"
            :disabled="false"
            class="jFormGroup"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.agama.$error}">
          <label> Agama </label>
          <j-single-select
            v-model="$v.data_master.agama.$model"
            :options="list_agama"
            placeholder="Pilih Agama"
            label="name"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.status_dalam_keluarga.$error}">
          <label> Status Dalam Keluarga </label>
          <j-input
            v-model="$v.data_master.status_dalam_keluarga.$model"
            placeholder="Status Dalam Keluarga"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.anak_ke.$error}">
          <label> Anak Ke </label>
          <j-input
            v-model="$v.data_master.anak_ke.$model"
            placeholder="Anak Ke"
            type="number"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.alamat_siswa.$error}">
          <label> Alamat Siswa </label>
          <j-textarea
            v-model="$v.data_master.alamat_siswa.$model"
            placeholder="Alamat Siswa"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.nomor_telepon_siswa.$error}">
          <label> Nomor Telepon Siswa </label>
          <j-input
            v-model="$v.data_master.nomor_telepon_siswa.$model"
            placeholder="Nomor Telepon Siswa"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.sekolah_asal.$error}">
          <label> Sekolah Asal </label>
          <j-input
            v-model="$v.data_master.sekolah_asal.$model"
            placeholder="Sekolah Asal"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.diterima_dikelas.$error}">
          <label> Diterima Di Kelas </label>
          <j-input
            v-model="$v.data_master.diterima_dikelas.$model"
            placeholder="Diterima Di Kelas"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.tanggal_diterima.$error}">
          <label> Tanggal Diterima </label>
          <j-datepicker
            v-model="$v.data_master.tanggal_diterima.$model"
            placeholder="Tanggal Diterima"
            format="MMM dd, yyyy"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.nama_ayah_kandung.$error}">
          <label> Nama Ayah Kandung </label>
          <j-input
            v-model="$v.data_master.nama_ayah_kandung.$model"
            placeholder="Nama Ayah Kandung"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.nama_ibu_kandung.$error}">
          <label> Nama Ibu Kandung </label>
          <j-input
            v-model="$v.data_master.nama_ibu_kandung.$model"
            placeholder="Nama Ibu Kandung"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.alamat_orang_tua.$error}">
          <label> Alamat Orang Tua </label>
          <j-textarea
            v-model="$v.data_master.alamat_orang_tua.$model"
            placeholder="Alamat Orang Tua"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.nomor_telepon_rumah.$error}">
          <label> Nomor Telepon Rumah </label>
          <j-input
            v-model="$v.data_master.nomor_telepon_rumah.$model"
            placeholder="Nomor Telepon Rumah"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.pekerjaan_ayah.$error}">
          <label> Pekerjaan Ayah </label>
          <j-input
            v-model="$v.data_master.pekerjaan_ayah.$model"
            placeholder="Pekerjaan Ayah"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.pekerjaan_ibu.$error}">
          <label> Pekerjaan Ibu </label>
          <j-input
            v-model="$v.data_master.pekerjaan_ibu.$model"
            placeholder="Pekerjaan Ibu"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.nama_wali_siswa.$error}">
          <label> Nama Wali Siswa </label>
          <j-input
            v-model="$v.data_master.nama_wali_siswa.$model"
            placeholder="Nama Wali Siswa"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.alamat_wali.$error}">
          <label> Alamat Wali </label>
          <j-textarea
            v-model="$v.data_master.alamat_wali.$model"
            placeholder="Alamat Wali"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.nomor_telepon_wali.$error}">
          <label> Nomor Telepon Wali </label>
          <j-input
            v-model="$v.data_master.nomor_telepon_wali.$model"
            placeholder="Nomor Telepon Wali"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.pekerjaan_wali.$error}">
          <label> Pekerjaan Wali </label>
          <j-input
            v-model="$v.data_master.pekerjaan_wali.$model"
            placeholder="Pekerjaan Wali"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.nomor_kitas.$error}">
          <label> NIK/No. KITAS </label>
          <j-input
            v-model="$v.data_master.nomor_kitas.$model"
            placeholder="NIK/No. KITAS"
            type="number"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.kewarganegaraan.$error}">
          <label> Kewarganegaraan </label>
          <j-input
            v-model="$v.data_master.kewarganegaraan.$model"
            placeholder="Kewarganegaraan"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.berkebutuhan_khusus.$error}">
          <label> Berkebutuhan Khusus </label>
          <j-input
            v-model="$v.data_master.berkebutuhan_khusus.$model"
            placeholder="Berkebutuhan Khusus"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.rt.$error}">
          <label> RT </label>
          <j-input
            v-model="$v.data_master.rt.$model"
            placeholder="RT"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.rw.$error}">
          <label> RW </label>
          <j-input
            v-model="$v.data_master.rw.$model"
            placeholder="RW"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.dusun.$error}">
          <label> Dusun </label>
          <j-input
            v-model="$v.data_master.dusun.$model"
            placeholder="Dusun"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.kelurahan.$error}">
          <label> Kelurahan/Desa </label>
          <j-input
            v-model="$v.data_master.kelurahan.$model"
            placeholder="Kelurahan/Desa"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.kecamatan.$error}">
          <label> Kecamatan </label>
          <j-input
            v-model="$v.data_master.kecamatan.$model"
            placeholder="Kecamatan"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.kode_pos.$error}">
          <label> Kode POS </label>
          <j-input
            v-model="$v.data_master.kode_pos.$model"
            placeholder="Kode POS"/>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <div class="float-to-right m__t--20">
          <b-button
            class="btn blue m__r--5"
            @click="saveData">
            Save
          </b-button>
          <b-button
            class="btn gray"
            @click="$router.replace('/data-siswa')">
            Cancel
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, no-console, max-len */
import { mapActions, mapState } from 'vuex';
import { required, requiredIf } from 'vuelidate/lib/validators';

export default {
  components: {
  },
  data() {
    return {
      title: {
        icon: 'fa-file',
        main_title: 'Create Data',
      },

      data_master: {
        nama_lengkap: '',
        nis: '',
        nisn: '',
        tempat_lahir: '',
        tanggal_lahir: null,
        jenis_kelamin: null,
        agama: null,
        status_dalam_keluarga: '',
        anak_ke: '',
        alamat_siswa: '',
        nomor_telepon_siswa: '',
        sekolah_asal: '',
        diterima_dikelas: '',
        tanggal_diterima: null,
        nama_ayah_kandung: '',
        nama_ibu_kandung: '',
        alamat_orang_tua: '',
        nomor_telepon_rumah: '',
        pekerjaan_ayah: '',
        pekerjaan_ibu: '',
        nama_wali_siswa: '',
        alamat_wali: '',
        nomor_telepon_wali: '',
        pekerjaan_wali: '',
        nomor_kitas: '',
        kewarganegaraan: '',
        berkebutuhan_khusus: '',
        rt: '',
        rw: '',
        dusun: '',
        kelurahan: '',
        kecamatan: '',
        kode_pos: '',
      },
      list_jenis_kelamin: [
        {
          value: 'Laki-Laki',
          text: 'Laki-Laki',
        },
        {
          value: 'Perempuan',
          text: 'Perempuan',
        },
      ],
      list_agama: [
        {
          id: 'Islam',
          name: 'Islam',
        },
        {
          id: 'Kristen/Protestan',
          name: 'Kristen/Protestan',
        },
        {
          id: 'Hindu',
          name: 'Hindu',
        },
        {
          id: 'Budha',
          name: 'Budha',
        },
        {
          id: 'Kong Hu Chu',
          name: 'Kong Hu Chu',
        },
        {
          id: 'Lainnya',
          name: 'Lainnya',
        },
      ],
    };
  },
  computed: {
  },
  watch: {
  },
  created() {
  },
  methods: {
    ...mapActions('jStoreKesiswaan', ['createSiswa']),

    saveData() {
      this.$v.data_master.$touch();
      if (!this.$v.data_master.$error) {
        const param = this.data_master;
        this.createSiswa(param).then((res) => {
          if (!res.data.error) {
            setTimeout(() => {
              this.$router.push('/data-siswa');
            }, 1500);
          }
        });
      }
    },
  },
  validations() {
    return {
      data_master: {
        nama_lengkap: { required },
        nis: { required },
        nisn: { required },
        tempat_lahir: {},
        tanggal_lahir: {},
        jenis_kelamin: {},
        agama: {},
        status_dalam_keluarga: {},
        anak_ke: {},
        alamat_siswa: {},
        nomor_telepon_siswa: {},
        sekolah_asal: {},
        diterima_dikelas: {},
        tanggal_diterima: {},
        nama_ayah_kandung: {},
        nama_ibu_kandung: {},
        alamat_orang_tua: {},
        nomor_telepon_rumah: {},
        pekerjaan_ayah: {},
        pekerjaan_ibu: {},
        nama_wali_siswa: {},
        alamat_wali: {},
        nomor_telepon_wali: {},
        pekerjaan_wali: {},
        nomor_kitas: {},
        kewarganegaraan: {},
        berkebutuhan_khusus: {},
        rt: {},
        rw: {},
        dusun: {},
        kelurahan: {},
        kecamatan: {},
        kode_pos: {},
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/bimbingan-konseling/absen/jAbsenCreate.vue